/*
 * Copyright (c) 2023 | All Rights Reserved
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *  Written by MeeCode by Mario Murrent
 */
import log, { LogLevelDesc, LogLevelNames } from 'loglevel';

const formatPrefix = (level: LogLevelNames): string => `${level.toUpperCase()}:`;

export const initLogger = (): void => {
  const level = (process.env.REACT_APP_LOG_LEVEL ?? 'debug') as LogLevelDesc;

  // Bind the prefix as the first argument of the raw console method so the
  // native console method is the direct callee at the call site. Browsers
  // attribute a console line to the nearest non-native caller, so binding
  // (rather than wrapping in a function) keeps devtools pointing at the code
  // that logged instead of at this file.
  log.methodFactory = (methodName) =>
    // eslint-disable-next-line no-console
    console[methodName].bind(console, formatPrefix(methodName));

  log.setLevel(level);
};

export const Logger = {
  get trace() {
    return log.trace;
  },
  get debug() {
    return log.debug;
  },
  get info() {
    return log.info;
  },
  get warn() {
    return log.warn;
  },
  get error() {
    return log.error;
  }
};
